var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { EDocumentCategory } from "../../types/document.types";
import { startOfDay, endOfDay, isEqual, isBefore, isAfter, } from "../../utils/date-fns.utils";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getMappedCountries } from "../../utils/location/location.utils";
import { EAreaOfBusinessActivities, EBanqupRentioDocumentType, EField, } from "./schema.createRentDeposit.types";
import { getBusinessRegisterUrl, getForeignersForBanqup, getIdDocumentsSummary, getNavigationTitle, getPayerForBanqup, getPayerVatNumber, getPrefilledBusinessActivity, getPrefilledDateOfIncorporation, getPrefilledIdDocuments, getPrefilledLegalForm, isFileExtensionValid, isFileSizeValid, UBO_REGISTER_URL, } from "./schema.createRentDeposit.utils";
var NOW = new Date();
var END_OF_DAY = endOfDay(NOW);
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b, _c;
        var _d, _e, _f;
        var selectedPayer = getPayerForBanqup(defaultValues, extraData);
        var foreigners = getForeignersForBanqup(initialValues, defaultValues, extraData);
        var isCompanyPayer = !!(selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.company) && !!extraData.hasCompaniesInBanqupEnabled;
        var requiredFields = [EField.PayerIdentityDocuments];
        if (foreigners.length > 0) {
            requiredFields.push(EField.BanqupIdentityDocuments);
        }
        if (isCompanyPayer) {
            requiredFields.push(EField.LegalForm, EField.DateOfIncorporation, EField.PrimaryBusinessActivity, EField.AreaOfBusinessActivities, EField.ShareholderPercentage, EField.Occupation, EField.BusinessRegisterDocument, EField.UboRegisterDocument);
        }
        return {
            required: requiredFields,
            properties: (_a = {},
                _a[EField.Header + "8"] = {
                    default: undefined,
                },
                _a[EField.PayerIdentityDocuments] = {
                    // @ts-ignore
                    default: (function () {
                        var _a;
                        var _b;
                        return [
                            __assign(__assign(__assign({}, ((selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.id) != null
                                ? getPrefilledIdDocuments([selectedPayer.id], extraData)
                                : {})), (((_b = getValue(EField.PayerIdentityDocuments, initialValues, defaultValues)) === null || _b === void 0 ? void 0 : _b[0]) || {})), (_a = {}, _a[EField.PayerIdentityDocumentAccountId] = selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.id, _a[EField.DocumentType] = EBanqupRentioDocumentType.IdCard, _a.contact = selectedPayer, _a)),
                        ];
                    })(),
                    type: "array",
                    items: {
                        type: "object",
                        required: [
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId,
                            EField.DateOfExpiry,
                            EField.DocumentNumber,
                            EField.DateOfIssuance,
                            EField.CountryOfIssuance,
                        ],
                        properties: (_b = {},
                            _b[EField.PayerIdentityDocumentAccountId] = {},
                            _b[EField.DocumentType] = {
                                default: EBanqupRentioDocumentType.IdCard,
                                // @ts-ignore
                                options: [
                                    EBanqupRentioDocumentType.IdCard,
                                    EBanqupRentioDocumentType.Passport,
                                ].map(function (id) { return ({
                                    id: id,
                                    value: getLocalizedText("rent_deposit.documentType.".concat(id.toLowerCase())),
                                }); }),
                            },
                            _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                                minLength: 1,
                            },
                            _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                                minLength: 1,
                            },
                            _b[EField.DocumentNumber] = {
                                default: getValue(EField.DocumentNumber, initialValues, defaultValues),
                            },
                            _b[EField.DateOfIssuance] = {
                                default: getValue(EField.DateOfIssuance, initialValues, defaultValues),
                            },
                            _b[EField.DateOfExpiry] = {
                                default: getValue(EField.DateOfExpiry, initialValues, defaultValues),
                            },
                            _b[EField.CountryOfIssuance] = {
                                default: getValue(EField.CountryOfIssuance, initialValues, defaultValues),
                                // @ts-ignore
                                options: getMappedCountries(),
                            },
                            _b),
                    },
                    uniqueItems: true,
                },
                _a[EField.Header + "9"] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (_) { return foreigners.length > 0; },
                },
                _a[EField.BanqupIdentityDocuments] = {
                    // @ts-ignore
                    default: foreigners,
                    // @ts-ignore
                    showIf: function (_) { return foreigners.length > 0; },
                    type: "array",
                    items: {
                        type: "object",
                        required: [
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId,
                        ],
                        properties: (_c = {},
                            _c[EField.IdentityDocumentAccountId] = {},
                            _c[EField.IdentityDocumentIdentityFrontDocumentId] = {
                                minLength: 1,
                            },
                            _c[EField.IdentityDocumentIdentityBackDocumentId] = {
                                minLength: 1,
                            },
                            _c),
                    },
                    uniqueItems: true,
                },
                // Company KYB section — shown only when payer is a company
                _a[EField.CompanyKybHeader] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.BusinessRegisterInfoBanner] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.UboRegisterInfoBanner] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                // The three fields below come from the KBO when the register holds them.
                // The KBO value takes precedence because the field is then disabled, so
                // it is the value that gets submitted.
                _a[EField.LegalForm] = {
                    default: (_d = getPrefilledLegalForm(defaultValues, extraData)) !== null && _d !== void 0 ? _d : getValue(EField.LegalForm, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.DateOfIncorporation] = {
                    default: (_e = getPrefilledDateOfIncorporation(defaultValues, extraData)) !== null && _e !== void 0 ? _e : getValue(EField.DateOfIncorporation, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.PrimaryBusinessActivity] = {
                    default: (_f = getPrefilledBusinessActivity(defaultValues, extraData)) !== null && _f !== void 0 ? _f : getValue(EField.PrimaryBusinessActivity, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.AreaOfBusinessActivities] = {
                    default: getValue(EField.AreaOfBusinessActivities, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                    // @ts-ignore
                    options: Object.values(EAreaOfBusinessActivities).map(function (id) { return ({
                        id: id,
                        value: getLocalizedText("rent_deposit.area_of_business_activities.".concat(id.toLowerCase())),
                    }); }),
                },
                _a[EField.ShareholderPercentage] = {
                    default: getValue(EField.ShareholderPercentage, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.Occupation] = {
                    default: getValue(EField.Occupation, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.BusinessRegisterDocument] = {
                    default: getValue(EField.BusinessRegisterDocument, initialValues, defaultValues),
                    minLength: 1,
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a[EField.UboRegisterDocument] = {
                    default: getValue(EField.UboRegisterDocument, initialValues, defaultValues),
                    minLength: 1,
                    // @ts-ignore
                    showIf: function (_) { return isCompanyPayer; },
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a, _b, _c;
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit.identity_documents.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "8"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
        },
        _a[EField.PayerIdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_b = {},
                _b[EField.PayerIdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _b[EField.DocumentType] = {
                    "ui:field": ERentioFormField.SegmentedControl,
                    title: getLocalizedText("rent_deposit.documentType.label"),
                    formatSummary: function (formData) {
                        return getLocalizedText("rent_deposit.documentType.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
                    },
                },
                _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: [
                        "application/pdf",
                        "image/heic",
                        "image/heif",
                        "image/jpeg",
                        "image/jpg",
                        "image/png",
                        "image/webp",
                    ],
                    multiple: false,
                    useExistingDocuments: true,
                    getExistingDocumentsWhereFilter: function () { return ({
                        categoryId: { eq: EDocumentCategory.IdCardFront },
                    }); },
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: [
                        "application/pdf",
                        "image/heic",
                        "image/heif",
                        "image/jpeg",
                        "image/jpg",
                        "image/png",
                        "image/webp",
                    ],
                    multiple: false,
                    useExistingDocuments: true,
                    getExistingDocumentsWhereFilter: function () { return ({
                        categoryId: { eq: EDocumentCategory.IdCardBack },
                    }); },
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _b[EField.DateOfExpiry] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.id_expiry_date.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b[EField.DocumentNumber] = {
                    "ui:field": ERentioFormField.Text,
                    title: getLocalizedText("rent_deposit.document_number.label"),
                },
                _b[EField.CountryOfIssuance] = {
                    "ui:field": ERentioFormField.DropdownSelect,
                    title: getLocalizedText("rent_deposit.country_of_issuance.label"),
                },
                _b[EField.DateOfIssuance] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.date_of_issuance.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b),
            formatSummary: function (docs) { return getIdDocumentsSummary(docs); },
        },
        _a[EField.Header + "9"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.identity_documents.heading"),
        },
        _a[EField.BanqupIdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_c = {},
                _c[EField.IdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _c[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    useExistingDocuments: true,
                    getExistingDocumentsWhereFilter: function () { return ({
                        categoryId: { eq: EDocumentCategory.IdCardFront },
                    }); },
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _c[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    useExistingDocuments: true,
                    getExistingDocumentsWhereFilter: function () { return ({
                        categoryId: { eq: EDocumentCategory.IdCardBack },
                    }); },
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _c),
            formatSummary: function (docs) { return getIdDocumentsSummary(docs); },
        },
        // Company KYB section
        _a[EField.CompanyKybHeader] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.company_kyb.heading"),
        },
        _a[EField.BusinessRegisterInfoBanner] = {
            "ui:field": ERentioFormField.HelpInfo,
            title: getLocalizedText("rent_deposit.business_register_info.title"),
            // Resolved from the store so the KBO link carries the payer company's
            // enterprise number, which is only known once a payer is selected.
            getSubtitle: function (state, formData) {
                return getLocalizedText("rent_deposit.business_register_info.description", {
                    url: getBusinessRegisterUrl(getPayerVatNumber(state, formData, extraData)),
                });
            },
            subtitleIsMarkdown: true,
        },
        _a[EField.UboRegisterInfoBanner] = {
            "ui:field": ERentioFormField.HelpInfo,
            title: getLocalizedText("rent_deposit.ubo_register_info.title"),
            subtitle: getLocalizedText("rent_deposit.ubo_register_info.description", {
                url: UBO_REGISTER_URL,
            }),
            subtitleIsMarkdown: true,
        },
        // A field is locked only when the KBO actually supplied a Banqup-accepted
        // value for it; otherwise the broker still has to fill it in.
        _a[EField.LegalForm] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("rent_deposit.legal_form.label"),
            isDisabled: function (formData) {
                return !!getPrefilledLegalForm(formData, extraData);
            },
        },
        _a[EField.DateOfIncorporation] = {
            "ui:field": ERentioFormField.Date,
            title: getLocalizedText("rent_deposit.date_of_incorporation.label"),
            formatSummary: function (input) { return input && formatDate(input); },
            isDisabled: function (formData) {
                return !!getPrefilledDateOfIncorporation(formData, extraData);
            },
        },
        _a[EField.PrimaryBusinessActivity] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("rent_deposit.primary_business_activity.label"),
            isDisabled: function (formData) {
                return !!getPrefilledBusinessActivity(formData, extraData);
            },
        },
        _a[EField.AreaOfBusinessActivities] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("rent_deposit.area_of_business_activities.label"),
            formatSummary: function (formData) {
                return getLocalizedText("rent_deposit.area_of_business_activities.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
            },
        },
        _a[EField.ShareholderPercentage] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("rent_deposit.shareholder_percentage.label"),
        },
        _a[EField.Occupation] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("rent_deposit.occupation.label"),
        },
        _a[EField.BusinessRegisterDocument] = {
            "ui:field": ERentioFormField.DocumentSelectInline,
            title: getLocalizedText("rent_deposit.business_register_document.label"),
            formatSummary: function (formData) {
                return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
            },
            accept: [
                "application/pdf",
                "image/heic",
                "image/heif",
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/webp",
            ],
            multiple: false,
        },
        _a[EField.UboRegisterDocument] = {
            "ui:field": ERentioFormField.DocumentSelectInline,
            title: getLocalizedText("rent_deposit.ubo_register_document.label"),
            formatSummary: function (formData) {
                return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
            },
            accept: [
                "application/pdf",
                "image/heic",
                "image/heif",
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/webp",
            ],
            multiple: false,
        },
        _a;
};
export var getPreSubmitAction = function (extraData) {
    return function (_a) {
        var _b;
        var formData = _a.formData, onSuccess = _a.onSuccess;
        (_b = extraData.preSubmitAction) === null || _b === void 0 ? void 0 : _b.call(extraData, formData, onSuccess);
    };
};
var validateDocumentFileErrors = function (file, errorTarget, allowedMBS) {
    if (!file) {
        return;
    }
    // An existing document selected from the dropdown is stored as its document
    // id (string), not a File — there is no local file to validate.
    if (typeof file === "string") {
        return;
    }
    if (!isFileExtensionValid(file)) {
        errorTarget === null || errorTarget === void 0 ? void 0 : errorTarget.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.missing_extension.error"));
    }
    else if (!isFileSizeValid(file, allowedMBS)) {
        errorTarget === null || errorTarget === void 0 ? void 0 : errorTarget.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
    }
};
export var getValidate = function () { return function (formData, errors) {
    var allowedMBS = 10;
    var _a = formData, _b = EField.BanqupIdentityDocuments, _c = _a[_b], banqupIdentityDocuments = _c === void 0 ? [] : _c, _d = EField.PayerIdentityDocuments, _e = _a[_d], payerIdentityDocuments = _e === void 0 ? [] : _e, _f = EField.BusinessRegisterDocument, _g = _a[_f], businessRegisterDocument = _g === void 0 ? [] : _g, _h = EField.UboRegisterDocument, _j = _a[_h], uboRegisterDocument = _j === void 0 ? [] : _j;
    // Checked before the two blocks below rather than after them. The payer identity document
    // block ends with an unconditional `return errors`, so anything placed after it only ran
    // when the step carried no payer identity document — which on a company deposit is never,
    // and a company deposit is the only kind that asks for these two documents at all. That is
    // why a 12 MB register document was accepted (DEV-2936). The banqup block above it returns
    // nothing and was never part of the problem.
    // `validateDocumentFileErrors` returns immediately for a field the step is not showing, so
    // running it first costs a personal deposit nothing.
    validateDocumentFileErrors(businessRegisterDocument[0], 
    // @ts-ignore
    errors[EField.BusinessRegisterDocument], allowedMBS);
    validateDocumentFileErrors(uboRegisterDocument[0], 
    // @ts-ignore
    errors[EField.UboRegisterDocument], allowedMBS);
    if (banqupIdentityDocuments.length > 0) {
        banqupIdentityDocuments.forEach(function (document, index) {
            var _a = document.identityBackDocument, identityBackDocument = _a === void 0 ? [] : _a, _b = document.identityFrontDocument, identityFrontDocument = _b === void 0 ? [] : _b;
            var _c = (errors[EField.BanqupIdentityDocuments] || [])[index] || {}, identityBackDocumentError = _c.identityBackDocument, identityFrontDocumentError = _c.identityFrontDocument;
            validateDocumentFileErrors(identityFrontDocument[0], identityFrontDocumentError, allowedMBS);
            validateDocumentFileErrors(identityBackDocument[0], identityBackDocumentError, allowedMBS);
        });
    }
    if (payerIdentityDocuments.length > 0) {
        var _k = payerIdentityDocuments[0], _l = _k.identityBackDocument, identityBackDocument = _l === void 0 ? [] : _l, _m = _k.identityFrontDocument, identityFrontDocument = _m === void 0 ? [] : _m, dateOfIssuance = _k.dateOfIssuance, dateOfExpiry = _k.dateOfExpiry;
        var _o = (errors[EField.PayerIdentityDocuments] || [])[0] || {}, dateOfIssuanceError = _o.dateOfIssuance, dateOfExpiryError = _o.dateOfExpiry, identityBackDocumentError = _o.identityBackDocument, identityFrontDocumentError = _o.identityFrontDocument;
        validateDocumentFileErrors(identityFrontDocument[0], identityFrontDocumentError, allowedMBS);
        validateDocumentFileErrors(identityBackDocument[0], identityBackDocumentError, allowedMBS);
        if (isAfter(dateOfIssuance, END_OF_DAY) && dateOfIssuanceError) {
            dateOfIssuanceError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_issue.error"));
            return errors;
        }
        if (!isAfter(dateOfExpiry, END_OF_DAY) && dateOfExpiryError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_expired.error"));
            return errors;
        }
        if (isEqual(startOfDay(dateOfExpiry), startOfDay(dateOfIssuance)) &&
            dateOfExpiryError &&
            dateOfIssuanceError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_same_as_date_of_issuance.error"));
            return errors;
        }
        if (isBefore(dateOfExpiry, dateOfIssuance) && dateOfExpiryError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_before_date_of_issuance.error"));
        }
        return errors;
    }
    return errors;
}; };
